import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=1d454b42&scoped=true&"
import script from "./BaseList.vue?vue&type=script&lang=js&"
export * from "./BaseList.vue?vue&type=script&lang=js&"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=1d454b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d454b42",
  null
  
)

export default component.exports